/**
 * 数据权限接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataPermissionService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 数据权限接口
  /**
   * 加载数据权限
   * @param param
   * @returns {Observable<any>}
   */
  queryDataSourcePageList(param) {
    const url = this.prefix + 'dataSource/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 选中下拉框某一项,获取表格中的数据
   * @param param
   * @returns {Observable<any>}
   */
  queryDataSourceValue(param) {
    const url = this.prefix + 'dataSource/queryValue';
    return this.http.Post(url, param);
  }

  /**
   * 删除数据权限
   * @param param
   * @returns {Observable<any>}
   */
  deleteDataSource(param) {
    const url = this.prefix + 'dataSource/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 修改，启用，禁用数据权限
   * @param param
   * @returns {Observable<any>}
   */
  updateDataSource(param) {
    const url = this.prefix + 'dataSource/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 保存数据权限
   * @param param
   * @returns {Observable<any>}
   */
  saveDataSource(param) {
    const url = this.prefix + 'dataSource/save';
    return this.http.Post(url, param);
  }

  /**
   * 获取数据权限
   * @param param
   * @returns {Observable<any>}
   */
  getDataSource(param) {
    const url = this.prefix + 'dataSource/queryById';
    return this.http.Post(url, param);
  }

  //#endregion

}
